export default __webpack_public_path__ + "bd3f5018c291d37e92b4385054a4da42.png";